<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.pelletFeeding')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/smeltingPreheatingKilnPara"><span>{{$t('tlt.smeltingPreheatingKilnPara')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/pelletFeeding"><span>{{$t('tlt.pelletFeeding')}}</span></router-link></li>
                </ul>
            </div>
        </div>

        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <mes-filter entity="pelletFeeding" />
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="pelletFeedingListTabel" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionResult">
                        <div class="card-body">
                            <mmf-table entity="pelletFeeding" inline-actions-disabled singleChoice></mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import MmfTable from "@/components/MmfTable";
import MesFilter from '@/components/MesFilter'

// 常量
const moduleName = "pelletFeeding";

export default {
  components: {
    MmfTable,
    MesFilter
  },
  methods: {
    ...mapActions(moduleName, ["jumpToEdit"]),
    ...mapActions("base", ["MMFLoadRows", "MMFNew"])
  },
  data() {
    return {
      moduleName: moduleName
    };
  }
};
</script>